import axios from "axios";

const consultCepAPI = axios.create({
  baseURL: "https://viacep.com.br/",
  timeout: 9000,
});

export default consultCepAPI;
